enum ChartType {
    DAILY,
    YEARLY
}

export default ChartType